export default __webpack_public_path__ + "static/media/ClientesNew.ea858596.svg";